import { api_url } from "../configiration/config";
import { axiosClone } from './../axiosClone';

//Faqs 
export async function getFaqs(){
    return await axiosClone.get(`${api_url}/faqs`);
}
//terms and conditions
export async function getTerms(){
    return await axiosClone.get(`${api_url}/headers/terms-and-conditions`);
  } 
//privacy and policy
export async function getPrivacyandPolicy(){
    return await axiosClone.get(`${api_url}/headers/privacy-policy`);
}